import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isFeatureEnabled, usePlatformContext } from "../context/PlatformContext";
import { getFeatureStatus } from "../utils/featureControl";
import { isAdminModuleEnabled } from "../config/features";

export default function FeatureGate({
  featureKey,
  uiFeatureKey,
  children,
  redirectTo = "/dashboard",
  requireAdmin = false,
}) {
  const location = useLocation();
  const { features, isLoading, status, user } = usePlatformContext();

  if (!featureKey && !uiFeatureKey) {
    return children;
  }

  if (isLoading || status === "missing" || status === "idle") {
    return null;
  }

  if (requireAdmin && !isAdminModuleEnabled(user)) {
    if (!redirectTo) return null;
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  const statusKey = uiFeatureKey || featureKey;
  const uiStatus = getFeatureStatus(statusKey);
  if (featureKey) {
    const enabled = isFeatureEnabled(features, featureKey);
    if (!enabled) {
      if (!redirectTo) return null;
      return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
    }
  }

  if (uiStatus.status === "disabled") {
    if (!redirectTo) return null;
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  if (uiStatus.status === "maintenance") {
    return (
      <div className="card p-6 text-center">
        <h2 className="text-lg font-semibold text-slate-900">
          This feature is under maintenance
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          {uiStatus.message || "This feature is under maintenance."}
        </p>
        {uiStatus.maintenanceType && (
          <p className="mt-2 text-xs uppercase tracking-wide text-slate-500">
            Maintenance type: {uiStatus.maintenanceType}
          </p>
        )}
        <div className="mt-4 text-xs text-slate-500">
          Please check back later.
        </div>
      </div>
    );
  }

  return children;
}
